function formatCarName(make: any, model: any) {
  const capitalize = (str: any) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  return `${capitalize(make)} ${capitalize(model)}`;
}
export default formatCarName;
